module.exports = __webpack_public_path__ + "img/pr-1.2f8fc64c.png";